<template>
  <div class="flex h-full w-full flex-col items-stretch gap-4">
    <slot name="header" />
    <div class="h-divider" />
    <slot name="info" />
    <div class="h-divider" />
    <slot name="chart" />
  </div>
  <slot />
</template>
<script setup lang="ts">
</script>
<style scoped lang="scss">

</style>